/**
 * Calculates the total sugars content based on provided ingredients.
 */
export function calculateTotalSugars(ingredients: Ingredients): number | null {
  const hasOnlyInvalidValues = ingredients.every(checkIfHasInvalidValues);

  if (hasOnlyInvalidValues) {
    return null;
  }

  const totalSugars = [...ingredients].reduce(addSugars, 0);

  return Math.round(totalSugars);
}

// ─────────────────────────────────────────────────────────────────────────────

function checkIfHasInvalidValues(ingredient: Ingredient) {
  return typeof ingredient.sugarsG !== 'number';
}

function addSugars(total: number, ingredient: Ingredient) {
  const sugars = typeof ingredient.sugarsG === 'number' ? ingredient.sugarsG : 0; // prettier-ignore
  const quantity = ingredient.quantity ?? 1;

  return total + sugars * quantity;
}

// ─── Types ───────────────────────────────────────────────────────────────────

type Ingredient = { sugarsG: number | null; quantity?: number };
type Ingredients = Ingredient[] | readonly Ingredient[];
